import Icon from "@client/controls/Icon/component";
import Image from "@client/controls/Image/component";
import classnames from "classnames";
import React from "react";
import "./style.less";

const _loaded = {};

export interface ImageLoaderProps {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  isLoading?: boolean;
  ratio?: number;
  alt?: string;
  src: string | null;
  style?: React.CSSProperties;
}

class ImageLoader extends React.PureComponent<ImageLoaderProps> {
  public state = {
    loaded: _loaded[this.props.src ?? ""]
  };

  public componentDidUpdate(prevProps: ImageLoaderProps) {
    if (prevProps.src !== this.props.src) {
      this.setState({ loaded: _loaded[this.props.src ?? ""] });
    }
  }

  public render() {
    if (!this.props.src)
      return <img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" />;

    const { alt, className, isLoading, ratio = 1, src, style } = this.props;
    const { loaded } = this.state;

    // TODO: proper solution
    if (this.props.src.startsWith("fa")) {
      return <Icon iconClassName={this.props.src} />;
    }

    // TODO: proper solution
    if (this.props.src.indexOf(".svg") >= 0) {
      return <Image className={className} src={this.props.src} onClick={this.props.onClick} />;
    }

    const imageStyle = {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "auto",
      ...(loaded ? {} : { display: "none" })
    } as React.CSSProperties;
    return (
      <div className={classnames("lazy-img-container", className)} style={{ ...(style || {}), aspectRatio: 1 / ratio }}>
        <Image
          alt={alt}
          src={src}
          onClick={this.props.onClick}
          style={imageStyle}
          onLoad={loaded ? undefined : this._onLoad}
        />

        {(!loaded || isLoading) && <div className="loading-placeholder" />}
      </div>
    );
  }

  private _onLoad = () => {
    _loaded[this.props.src ?? ""] = true;
    this.setState({ loaded: true });
  };
}

export default ImageLoader;
